import React from 'react'
import { Grid, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";


const imgUrls = [
  imgUrl.integratedSymbol,
  imgUrl.analyticsSymbol,
  imgUrl.aiSymbol,
  imgUrl.countrySymbol,
  imgUrl.multichannelSymbol
];


const features = [
  { title: "Interoperable", desc: "The OpenLMIS solutions are interoperable with existing data systems" },
  { title: "Advanced Analytics", desc: "Advanced analytics for real-time action" },
  { title: "AI enabled", desc: "AI for predicting stock-outs and optimization" },
  { title: "Country owned", desc: "Hosted in country server hence fully owned by the countries" },
  { title: "Multi-channel", desc: "Available on all channels - web and mobile app in both online and offline mode" },
];

function OpenLmisFeatures() {
  return (
    <div style={{backgroundColor: '#fff'}}>
      <Grid container spacing={3} alignItems="center" justifyContent="center" padding={2}>
      
      {/* Left Side: Image/Mockup Section */}
      <Grid size={{ xs: 12, sm:6 , md: 6 , lg:6}}>
        <Box sx={{p:5}}>
          <img src={imgUrl.openLmisdashboard} className="w-100" />       
        </Box>
      </Grid>

      {/* Right Side: Text Section */}
      <Grid size={{ xs: 12, sm:6 , md: 6 , lg:6 }}>
        {features.map((feature, index) => (
        <div key={index} className="featuresList" style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
          <img src={imgUrls[index]} alt={feature.title} style={{ width: 50, height: 50, marginRight: 16, objectFit: 'contain' }} />
          <Typography>
            <span style={{ color: "#6e1b9b", fontWeight: 700 }}>{feature.title}:</span> {feature.desc}
          </Typography>
        </div>
      ))}

      </Grid>
    </Grid>
    </div>
  )
}

export default OpenLmisFeatures
